module.exports = __webpack_public_path__ + "img/_SDI9422.6fe9e066.jpg";